import { SvgIcon } from '@/common/components/SvgIcon'

const ListOpenIcon = () => <SvgIcon name="square-plus" width={16} height={16} className="text-brand-red" />

export default ListOpenIcon
